<template>
    <basic-container>
      <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
         
          <el-col :span="6">
            <el-form-item label="购买人" prop="purchaseUserName">
              <el-input
                clearable
                v-model="searchForm.purchaseUserName"
                placeholder="购买人"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="设备类型" prop="deviceTypeName">
              <el-input
                clearable
                v-model="searchForm.deviceTypeName"
                placeholder="设备类型"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
  
         
          <el-col :span="12">
            <el-form-item label="金额区间" prop="elderlyName">
              <div style="display: flex;">
                <money-input
                 v-model="searchForm.orderAmountLower"
              
              
                style="width: 40%"
              />
              <money-input
                 v-model="searchForm.orderAmountUpper"
              
                
                style="width: 40%"
              />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="购买日期" prop="elderlyName">
              <el-date-picker
              v-model="searchForm.daterange"
              style="width: 100%;"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div style="float: right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
      >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            reduceHeight="20"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>
  
     
     
      </avue-crud>
  
    
    </basic-container>
  </template>
  <script>
 
  import {deviceOrderPage,modelListByTypeId } from '@/api/nursingHome/artificalDevice';

  import { getDictionary } from '@/api/common.js';
  import searchFromShow from '@/components/search-form-show/index';
  import {
 
  getDeviceTypeList,
  
} from '../api/serveItemManage';

  export default {
    components: { searchFromShow},
    data() {
      return {
        
        searchForm: {
          purchaseUserName: '',
          orderAmountLower: '',
          daterange:[],
          deviceTypeName: '',
          orderAmountUpper: '',
          orderTimeStart: '',
          orderTimeEnd: '',
        },
  
   
        option: {
          selection: false,
          select: true,
          index: true,
          indexLabel: '#',
          page: true,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '设备名称',
              prop: 'deviceName',
            },
            
            {
              label: '设备型号',
              prop: 'deviceModelName',
            },
            {
              label: '编号',
              prop: 'deviceCode',
            },
            {
              label: '设备类型',
              prop: 'deviceTypeName',
            },
            {
              label: '所属设备大类',
              
              type: 'select',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_device_category',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
              prop: 'deviceCategory',
            },
           
            {
              label: '购买人',
              prop: 'purchaseUserName',
            },
            {
              label: '购买时间',
              prop: 'orderTime',
            },
            {
              label: '购买金额',
              prop: 'orderAmount',
            },
            {
              label: '付款渠道',
              prop: 'purchaseChannel',
            },
            {
              label: '配送地址',
              prop: 'deliverAddr',
            },
            {
              label: '配送时间',
              prop: 'deliverTime',
            },
          ],
        },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        loading: false,
        searchBoxFlag: true,
        searchHeight: '',
        selectionList: [],
        recordIds: [],
        canteenList: [],
        warehouseList: [],
        selectionIds: '',
        formRow: {},
        nursinghomeIdList: [],
        deviceTypeIdList: [],
        onlineStatusList: [],
        deviceStatuseList: [],
      };
    },
    created() {
      this.initData();
    },
    computed: {
    
    },
    mounted() {
      this.calcHeight();
    },
    activated() {
      // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
      this.$nextTick(() => {
        this.$refs.crud.refreshTable();
      });
    },
    methods: {
     
      searchRecord(){
        this.page.currentPage = 1
        if(this.searchForm.daterange&&this.searchForm.daterange.length>0){
          this.searchForm.orderTimeStart = this.dayjs(this.searchForm.daterange[0]).format('YYYY-MM-DD 00:00:00')
          this.searchForm.orderTimeEnd =  this.dayjs(this.searchForm.daterange[1]).format('YYYY-MM-DD 23:59:59')
        }else{
          this.searchForm.orderTimeStart = ''
          this.searchForm.orderTimeEnd = ''
          
        }
        this.onLoad()
      },
      searchClear() {
        this.tool.clearObject(this.searchForm, 'nursinghomeId');
        this.searchForm.type = '0';
      },
  
      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
      },
      initData() {
       
       
        
        
      },
  
      onLoad() {
        
          this.loading = true;
  
          deviceOrderPage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }
  
  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  </style>
  <style>
  #alarmRule > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
  </style>
  